<template>
  <div class="codeTest">
    <div class="crumbs">
      <img class="a1" @click="$router.go(-1)" src="@/assets/newicons/i001.png" alt="">
      <span style="margin-right:10px">返回</span>
       <el-divider direction="vertical"></el-divider>
      <span style="margin-left:10px">代码安装检测</span>
    </div>

    <!-- <div class="siteHead">
      <span>代码安装检测</span>
    </div> -->
    <div class="testContent">
      <!-- <div class="hint">
        <div class="a1"> <i class="el-icon-warning"></i> <span>温馨提示：</span>   </div>
        <div class="a2">
          <p>1.为全面识别访客，请在网站的上正确安装统计代码；</p>
          <p>2.本功能通过抓取网站页面，分析是否安装了正确的统计代码，但有的网站打开速度较慢，或者限制程序抓取网页，会导致系统无法判断。这种情况下，请联系网站管理员了解代码的实际安装情况；</p>
          <p>3.正确安装统计代码后，一般10分钟左右后，即可以查看到相关的识别统计数据，请耐心等待。</p>
        </div>
      </div> -->

      <div class="main1" style="padding-top:44px;padding-left:206px">

          <div class="title">检查范围：</div>
          <div class="Range">
            <div>
              <el-radio v-model="radio" label="1">默认站点</el-radio>
              <span v-if="options.length>0">{{options[options.length-1].siteName}}</span>
            </div>
            <div>
              <el-radio v-model="radio" label="2">其他站点</el-radio>
              <el-select v-model="selectId" placeholder="请选择" popper-class="popClass">
                <el-option v-for="item in options" :key="item.id" :label="item.siteName" :value="item.id">{{item.siteName}}</el-option>
              </el-select>
            </div>
            <div class="fx" style="margin-bottom: 38px;">
              <el-button type="dialog-confirm" @click="clickCheck">开始检测</el-button>
              <div v-loading="loading" element-loading-spinner="el-icon-loading" element-loading-text="检测过程需要一点时间，请待心等待！"></div>
            </div>
            <!-- <ul class="mt-20 steps">
              <li>1.检测过程中会打开一个弹窗，如果您的浏览器禁止弹窗，请允许弹窗</li>

              <li>2.整个检测过程大概需要1分钟时间</li>

              <li>3.请等检测完毕再关闭弹窗</li>
            </ul> -->
            <p :class="['status001', (codeTest == 1 || codeTest == 2)?'fu-ll':'']" v-if="codeTest==1" style="color:#999999;font-size:13px">页面代码安装状态：<span style="color: rgba(255, 80, 0, 1);">尚未检测到代码！</span>请阅读<router-link to="/zxk/junbros/codeExplain" style="color: #5088FF">代码安装页面说明</router-link></p>
            <p :class="['status001', (codeTest == 1 || codeTest == 2)?'fu-ll':'']" v-if="codeTest==2" style="color:#999999;font-size:13px">页面代码安装状态：<span style="color: #409EFF;">代码检测成功</span></p>
          </div>


      </div>


<div style="padding-left:274px" :class="[(codeTest == 1 || codeTest == 2)?'fu-ll':'']">

          <div class="hint cls001">
            <div class="a1"> <i class="el-icon-warning"></i> <span style="font-size:13px">温馨提示：</span>   </div>
            <div class="a2">
              <p>1.检测过程中会打开一个弹窗，如果您的浏览器禁止弹窗，请允许弹窗</p>
              <p>2.整个检测过程大概需要1分钟时间</p>
              <p>3.请等检测完毕再关闭弹窗</p>

              
            </div>
          </div>
</div>



      <div class="hint" style="margin: 0 -24px;margin-top:123px;background: none;padding:0;padding-top: 23px;border-top: 1px solid rgba(241, 241, 242, 1);padding-left:24px;padding-right:24px">
        <div class="a1">  <span style="margin-left:0px">小贴士：</span>   </div>
        <div class="a2" style="   line-height: 22px; padding-left: 0px;">
          <p>1.为全面识别访客，请在网站的上正确安装统计代码；</p>
          <p>2.本功能通过抓取网站页面，分析是否安装了正确的统计代码，但有的网站打开速度较慢，或者限制程序抓取网页，会导致系统无法判断。这种情况下，请联系网站管理员了解代码的实际安装情况；</p>
          <p>3.正确安装统计代码后，一般10分钟左右后，即可以查看到相关的识别统计数据，请耐心等待。</p>
        </div>
      </div> 


    </div>
    <!-- <ul class="tips">
      <p>小贴士</p>

      <li>1.为全面识别访客，请在网站的上正确安装统计代码；</li>

      <li>2.本功能通过抓取网站页面，分析是否安装了正确的统计代码，但有的网站打开速度较慢，或者限制程序抓取网页，会导致系统无法判断。这种情况下，请联系网站管理员了解代码的实际安装情况；</li>

      <li>3.正确安装统计代码后，一般10分钟左右后，即可以查看到相关的识别统计数据，请耐心等待。</li>
    </ul> -->
    <setDrawer ref="setDrawer" />
  </div>
</template>

<script>
import setDrawer from '../components/setDrawer'
import { siteSelectList, checkMainUrl } from '../api/newClueApi'
export default {
  components: {
    setDrawer
  },
  data () {
    return {
      selectId: '',
      radio: '1',
      options: [],
      loading: false,
      codeTest: 0
    }
  },
  methods: {
    siteSelectList () {
      siteSelectList({}).then(res => {
        this.options = res.data
      })
    },
    clickCheck () {
      var data = {}
      var jumpUrl = ''
      if (this.radio === '1') {
        if (this.options.length === 0) {
          this.$message.warning('请先添加站点')
          return
        }
        this.loading = true
        data = {
          mainUrl: this.options[this.options.length - 1].mainUrl,
          siteName: this.options[this.options.length - 1].siteName,
          name: this.options[this.options.length - 1].name
        }
        jumpUrl = this.options[this.options.length - 1].inputUrl
      } else {
        if (!this.selectId) {
          this.$message.warning('请选择站点')
          return
        }
        this.loading = true
        this.options.forEach(i => {
          if (i.id === this.selectId) {
            data = {
              mainUrl: i.mainUrl,
              siteName: i.siteName,
              name: i.name
            }
            jumpUrl = i.inputUrl
          }
        })
      }
      if (jumpUrl.indexOf('http')== -1 && jumpUrl.indexOf('https') == -1) {
        window.open('https://' + jumpUrl) 
      } else {
        window.open(jumpUrl,)
      }
      checkMainUrl(data).then(res => {
        this.loading = false
        this.$message.success('检测成功')
        this.codeTest = 2
      }).catch((res) => {
        if (res.data.code == 411) {
          this.codeTest = 1
        }
        this.loading = false
      })
    }
  },
  mounted () {
    this.siteSelectList()
  }
}
</script>

<style lang="scss" scoped>
.codeTest{
  background: #FFFFFF;
  box-shadow: 0px 1px 5px 0px rgba(38, 38, 38, 0.1);
  border-radius: 4px;
  .crumbs{
    padding: 0 20px;
    font-size: 16px;
    font-weight: 600;
    height: 50px;
    color: #343951;
    background: #FAFAFD;
    border-radius: 4px 4px 0px 0px;
    line-height: 22px;
    display: flex;
    align-items: center;
    .a1{
      width: 20px;
      height: 20px;
      margin-right: 16px;
      cursor: pointer;
    }
  }
}




.popClass  .el-select-dropdown__item{
  max-width: 225px;
}
.siteHead {
  background: #fff;
  padding: 15px 20px;
  border-radius: 5px;
  > span {
    font-size: 16px;
    color: #333;
  }
}
.mt-10 {
  margin-bottom: 10px;
}
.testContent {
  background: #fff;
  padding: 16px 24px;
  // padding-bottom: 140px;
      // box-shadow: 0px 1px 5px 0px rgba(38,38,38,0.1000);
    border-radius: 4px;
  .title {
    font-size: 16px;
  }
  .hint{
    background: rgba(237, 255, 237, 0.5);
    border-radius: 4px;
    padding: 10px;
    .a1{
      display: flex;
      align-items: center;
      font-size: 14px;
      font-weight: 400;
      color: #262626;
      line-height: 20px;
      i{
        font-size: 16px;
        color: rgba(48, 191, 120, 1);
      }
      span{
        font-size: 14px;
        margin-left: 10px;
      }
    }
    .a2{
      margin-top: 4px;
      font-size: 13px;
      font-weight: 400;
      color: #8C8C8C;
      line-height: 20px;
      padding-left: 26px;
    }
    p{
      font-size: 13px;
    }
  }
  .main1{
    display:flex;
    padding-top: 25px;
    padding-left: 49px;
    font-size: 14px;
    font-weight: 400;
    color: #333333;
    line-height: 20px;
    .title{
      font-size: 14px;
    }
  }
}
.tips {
  background: #fff;
  padding: 30px 20px 20px 20px;
  border-top: 1px dashed #ddd;
  > p {
    font-size: 14px;
    margin-bottom: 15px;
  }
  * {
    font-size: 12px;
  }
}
.mt-20 {
  margin-top: 20px;
}
.steps {
  li {
    color: #d9011c;
  }
}
.Range {
  > div {
    margin-bottom: 25px;
    /deep/ .el-radio__label {
      font-size: 16px;
    }
  }
}
/deep/.el-loading-parent--relative {
  width: 100%;
  line-height: 40px;
}
/deep/ .el-loading-spinner i {
  position: absolute;
  left: 15px;
  top: 10px;
  font-size: 25px;
}

/deep/ .el-radio__label{
  font-size: 14px !important;
}
.cls001{
  font-size: 13px;
  width: 459px;
  height: 103px;
  border: 1px solid #CAEFDC;
}
.status001{
  margin-bottom: 15px;
}
.fu-ll{
  margin-left: -78px;
}
</style>